import ApplicationController from "./application_controller"

// Controller for form validation
// Usage: <form data-controller="form-validation"
//                     data-action="submit->form-validation#validate">
//   <input data-form-validation-target="field"
//          data-validate="required email"
//          data-error-message="Email is required">
// </form>

export default class extends ApplicationController {
  static targets = [ "field", "submit" ]

  connect() {
    this.fieldTargets.forEach(field => {
      field.addEventListener('blur', () => this.validateField(field))
    })
  }

  validate(event) {
    let isValid = true

    this.fieldTargets.forEach(field => {
      if (!this.validateField(field)) {
        isValid = false
      }
    })

    if (!isValid) {
      event.preventDefault()
      this.dispatch("form-validation:failed")
    } else {
      this.dispatch("form-validation:success")
    }
  }

  validateField(field) {
    const validations = (field.dataset.validate || '').split(' ')
    const value = field.value.trim()
    let isValid = true

    // Remove previous error messages
    this.clearErrors(field)

    validations.forEach(validation => {
      switch(validation) {
        case 'required':
          if (!value) {
            this.showError(field, field.dataset.errorMessage || 'The field is required')
            isValid = false
          }
          break

        case 'email':
          if (value && !this.isValidEmail(value)) {
            this.showError(field, 'Type a valid email address')
            isValid = false
          }
          break

        case 'phone':
          if (value && !this.isValidPhone(value)) {
            this.showError(field, 'Type a valid phone number')
            isValid = false
          }
          break
      }
    })

    if (isValid) {
      field.classList.remove('is-invalid')
      field.classList.add('is-valid')
    }

    return isValid
  }

  clearErrors(field) {
    const errorElement = field.parentElement.querySelector('.invalid-feedback')
    if (errorElement) {
      errorElement.remove()
    }
    field.classList.remove('is-invalid', 'is-valid')
  }

  showError(field, message) {
    field.classList.add('is-invalid')

    const errorElement = document.createElement('div')
    errorElement.className = 'invalid-feedback'
    errorElement.textContent = message

    field.parentElement.appendChild(errorElement)
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  isValidPhone(phone) {
    return /^[\d\s\-\+\(\)]+$/.test(phone) && phone.replace(/\D/g, '').length >= 10
  }
}
